// removed by extract-text-webpack-plugin
module.exports = {"root":"Editor__root___3kU3i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Editor/Editor.scss
// module id = 977
// module chunks = 0